/* PIC: remove known first-party vendor cookies after an explicit refusal.
 * Complianz remains the sole consent UI/owner. No tracking/consent writes.
 * Never touch cart, Shopify, CMP, unknown cookies or third-party storage.
 */
(() => {
  'use strict';
  const analytics = /^(?:_ga(?:_.+)?|_gid|_gat(?:_.+)?)$/;
  const marketing = /^(?:_gcl_(?:au|aw|dc)|_fbp|_fbc|_ttp|ttcsid(?:_.+)?|__kla_id)$/;
  const hostname = location.hostname;
  const domains = ['', hostname, '.' + hostname];
  if (hostname.endsWith('.pic-shop.com')) domains.push('pic-shop.com', '.pic-shop.com');

  function cleanup() {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.currentVisitorConsent !== 'function') return false;
    const consent = privacy.currentVisitorConsent();
    // An empty preference is not an explicit refusal. Category choices stay independent.
    const denyAnalytics = consent.analytics === 'no';
    const denyMarketing = consent.marketing === 'no';
    if (!denyAnalytics && !denyMarketing) return true;
    document.cookie.split(';').forEach(part => {
      const name = part.trim().split('=')[0];
      if (!(denyAnalytics && analytics.test(name)) && !(denyMarketing && marketing.test(name))) return;
      domains.forEach(domain => {
        document.cookie = name + '=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax; Secure' + (domain ? '; domain=' + domain : '');
      });
    });
    return true;
  }

  document.addEventListener('visitorConsentCollected', () => {
    cleanup();
    // Re-read current choices each time; also catch already in-flight vendor callbacks.
    [100, 500, 1500, 4000].forEach(delay => setTimeout(cleanup, delay));
  });
  let attempts = 0;
  function ready() {
    if (!cleanup() && ++attempts < 100) setTimeout(ready, 100);
  }
  ready();
})();
